const Index = () => import(/* webpackChunkName: "order-inhouse" */ "./index.vue");
const List = () => import(/* webpackChunkName: "order-inhouse" */ "@/modules/Order/components/List.vue");
const Create = () => import(/* webpackChunkName: "order-inhouse" */ "@/modules/Order/components/InHouse/Create.vue");
const CatalogCreate = () => import(/* webpackChunkName: "order-catalog" */ "@/modules/Order/components/Catalog/Create.vue");
const Edit = () => import(/* webpackChunkName: "order-inhouse" */ "@/modules/Order/components/InHouse/Edit.vue");
const Home = () => import(/* webpackChunkName: "order-inhouse" */ "@/modules/Order/view/Home.vue");

export default [
  {
    path: "/order",
    name: "inhouse-order",
    component: Index,
    redirect: { name: "inhouse-order-home" },
    meta: {
      title: "In-House Orders",
      orderType: "inHouse",
    },
    children: [
      {
        path: "home",
        name: "inhouse-order-home",
        component: Home,
        meta: {
          title: "In-House Order Home",
          orderType: "inHouse",
        },
      },
      {
        path: "list",
        name: "inhouse-order-list",
        component: List,
        meta: {
          title: "In-House Order List",
          orderType: "inHouse",
        },
      },
      {
        path: "create",
        name: "inhouse-order-create",
        component: Create,
        meta: {
          title: "Create In-House Order",
          orderType: "inHouse",
        },
      },
      {
        path: "catalog/create",
        name: "catalog-order-create",
        component: CatalogCreate,
        meta: {
          title: "Create Catalog Order",
          orderType: "catalog",
        },
      },
      {
        path: ":id/edit",
        name: "inhouse-order-edit",
        component: Edit,
        meta: {
          title: "Edit In-House Order",
          orderType: "inHouse",
        },
      },
    ],
  },
];